import { useState, useCallback } from 'react';
import amarreApiService from '../services/amarreApiService';

function useAmarreData() {
  const [tipoOperativos, setTipoOperativos] = useState([]);
  const [operativos, setOperativos] = useState([]);
  const [lugares, setLugares] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const cargarTipoOperativos = useCallback(async () => {
    try {
      const data = await amarreApiService.getTipoOperativos();
      setTipoOperativos(data);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  const cargarOperativos = useCallback(async (tipoOperativo) => {
    setOperativos([]);
    if (!tipoOperativo) return;
    try {
      const data = await amarreApiService.getOperativos(tipoOperativo);
      setOperativos(data);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  const cargarLugares = useCallback(async (tipoOperativo) => {
    setLugares([]);
    if (!tipoOperativo) return;
    try {
      const data = await amarreApiService.getLugares(tipoOperativo);
      setLugares(data);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  const buscarParticipantes = useCallback(async (filtros) => {
    setLoading(true);
    setError(null);
    setParticipantes([]);
    try {
      const data = await amarreApiService.getParticipantes(filtros);
      const mappedParticipantes = data.map(p => ({
        id: p.legajo,
        nombre: p.nombre,
        legajo: p.legajo,
        displayName: p.nombre,
      }));
      setParticipantes(mappedParticipantes);
      return mappedParticipantes;
    } catch (err) {
      setError(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    tipoOperativos,
    operativos,
    lugares,
    participantes,
    loading,
    error,
    cargarTipoOperativos,
    cargarOperativos,
    cargarLugares,
    buscarParticipantes,
  };
}

export default useAmarreData;
